import { Breadcrumbs, Crumb } from '@/components/breadcrumbs';
import { defaultRichTextComponents } from '@/components/RichText';
import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { tinaField } from 'tinacms/dist/react';
import { TinaMarkdown } from 'tinacms/dist/rich-text';
import { layout } from '../../../styles/layout';
import '../../../styles/tokens.stylex';
import { borderRadius, layoutTokens, spacing } from '../../../styles/tokens.stylex';
import { typography } from '../../../styles/typography';
import { extractPlainTextFromAST } from '@/utils/extractPlainTextFromAST';
import { BlogPostByBreadcrumbsData, GlobalsQueryData } from '../../../lib/tinaQueries';
import { PageLayout } from '@/components/PageLayout/pageLayout';
type BlogPostServerProps = {
  globalsData: GlobalsQueryData;
  blogPostData: BlogPostByBreadcrumbsData;
  breadcrumbs: Crumb[];
};
export function BlogPostServer({
  blogPostData,
  globalsData,
  breadcrumbs
}: BlogPostServerProps) {
  const {
    post
  } = blogPostData;
  const lastUpdated = post.publishDate ? new Date(post.publishDate).toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }) : undefined;
  return <PageLayout showNavs={true} headerActions={[]} globalData={globalsData}>
      <section {...stylex.props(layout.sectionWrapper)}>
        <div {...stylex.props(layout.maxWidthWrapper, sx.innerLayoutWrapper)}>
          {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} styles={sx.breadcrumbs} />}
          <div className="xgu5lr5 x12h1iku xrvj5dj xtpsss9 x1pt1dkn x1qp1h42 x7v7x1q">
            <h1 {...stylex.props(typography.display1, sx.content)} data-tina-field={tinaField(post, 'title')}>
              {post.title}
            </h1>
            <div className="xm3ov88 x78zum5 x16pmaob x6s0dn4">
              {post.author?.image && <div className="xng8ra x1247r65 x4dzasd x7giv3 x1n2onr6">
                  <Image src={post.author.image} alt={post.author?.alt || ''} fill className="xl1xv1r" data-tina-field={tinaField(post, 'author')} sizes="60px" />
                </div>}
              <p {...stylex.props(typography.small)} data-tina-field={tinaField(post, 'author')}>
                {`${lastUpdated} by ${post.author?.staffName}`}
              </p>
            </div>
            <div className="xrvj5dj x1osaytk x4w6khx xxhr3t" data-tina-field={tinaField(post, 'peg')}>
              <TinaMarkdown content={post.peg} components={defaultRichTextComponents} />
            </div>
            <div className="xhvus0l xjhi37u x1kbrr3r x1skrob4 x1n2onr6 x7giv3">
              <Image alt={post.alt} src={post.image} fill className="xl1xv1r" data-tina-field={tinaField(post, 'image')} sizes="100%, (min-width: 920px): 920px" />
            </div>
            <div className="xrvj5dj x1osaytk x4w6khx xxhr3t" data-tina-field={tinaField(post, 'body')}>
              <TinaMarkdown content={post.body} components={defaultRichTextComponents} />
            </div>
          </div>
        </div>
      </section>
      <section>
        {/* Add JSON-LD to your page */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: `
                {
                "@context": "https://schema.org",
                "@type": "BlogPosting",
                "headline": "${post.title}",
                "image": "${post.image}",
                "author": {
                  "@type": "Person",
                  "name": "${post.author?.staffName}"
                },
                "datePublished": "${lastUpdated}",
                "dateModified": "${post.lastUpdated}",
                "publisher": {
                  "@type": "Organization",
                  "name": "A&O 3PL Fulfilment and Direct Mail",
                  "logo": {
                    "@type": "ImageObject",
                    "url": "https://ik.imagekit.io/aomail/es-assets/ao-logo.png"
                  }
                },
                "description": "${extractPlainTextFromAST(post.peg)}",
                "articleBody": "${extractPlainTextFromAST(post.body)}",
                "mainEntityOfPage": {
                  "@type": "WebPage",
                  "@id": "https://www.aomail.com.au/blog/${post._sys.breadcrumbs.join('/')}"
                }
              }
              `
      }} />
        {/* ... */}
      </section>
    </PageLayout>;
}
const sx = {
  innerLayoutWrapper: {
    k1xSpc: "xrvj5dj",
    khm7nJ: "xoj8i6",
    $$css: true
  },
  content: {
    kBCFzs: "xm3ov88",
    $$css: true
  },
  breadcrumbs: {
    keoZOQ: "x1cs223g",
    $$css: true
  }
};